/* MY TOP SHOP — interactions (reveal, statut boutique, onglets, header) */
(function () {
  var d = document;

  function reveal(root) {
    var els = (root || d).querySelectorAll('[data-mt-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Statut ouvert / fermé — horaires validés : lun–sam 11:00–22:00, dim 14:00–22:00 (Europe/Paris) */
  function status() {
    var nodes = d.querySelectorAll('[data-mt-status]');
    if (!nodes.length) return;
    var parts = {};
    new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var wd = (parts.weekday || '').replace('.', '').toLowerCase();
    var t = parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10);
    var open = wd === 'dim' ? 14 * 60 : 11 * 60;
    var close = 22 * 60;
    var isOpen = t >= open && t < close;
    var label;
    if (isOpen) label = 'Ouvert · ferme à 22:00';
    else if (t < open) label = 'Fermé · ouvre à ' + (wd === 'dim' ? '14:00' : '11:00');
    else label = 'Fermé · ouvre demain à ' + (wd === 'sam' ? '14:00' : '11:00');
    nodes.forEach(function (el) {
      el.textContent = label;
      var pill = el.closest('.mt-status');
      if (pill) pill.classList.toggle('is-open', isOpen);
    });
  }

  function tabs(root) {
    (root || d).querySelectorAll('[data-mt-tabs]').forEach(function (wrap) {
      if (wrap.dataset.mtReady) return;
      wrap.dataset.mtReady = '1';
      var list = wrap.querySelectorAll('[role="tab"]');
      list.forEach(function (tab) {
        tab.addEventListener('click', function () {
          list.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
          wrap.querySelectorAll('[role="tabpanel"]').forEach(function (p) {
            var show = p.id === tab.getAttribute('aria-controls');
            p.hidden = !show;
            p.classList.toggle('is-shown', show);
            if (show) p.querySelectorAll('[data-mt-reveal]').forEach(function (el) { el.classList.add('is-in'); });
          });
          var more = wrap.querySelector('[data-mt-more]');
          if (more && tab.dataset.url) { more.href = tab.dataset.url; var lbl = more.querySelector('span'); if (lbl && tab.dataset.label) lbl.textContent = tab.dataset.label; }
        });
      });
    });
  }

  function header() {
    var nav = d.querySelector('.mt-nav');
    if (!nav) return;
    var main = d.getElementById('MainContent');
    var on = function () {
      var y = main ? -main.getBoundingClientRect().top : window.scrollY;
      nav.classList.toggle('is-scrolled', y > 8);
    };
    on();
    d.addEventListener('scroll', on, { passive: true, capture: true });
    d.querySelectorAll('.mt-drawer').forEach(function (dt) {
      dt.addEventListener('toggle', function () { d.documentElement.style.overflow = dt.open ? 'hidden' : ''; });
      dt.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { dt.open = false; }); });
    });
  }

  function init(root) { reveal(root); tabs(root); status(); }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); header(); });
  else { init(); header(); }
  setInterval(status, 60000);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
